import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";

const servicesMeta = {
    legal: {
        title: "Услуга юридического сопровождения",
        items: [
            "Типы договоров",
            "Выбор услуги",
            "Юридическое заключение",
            "Выдача договора (1–7 рабочих дней)",
            "Консультация (онлайн/оффлайн, выбор и согласование времени)",
        ],
    },
    accounting: {
        title: "Услуга бухгалтерского сопровождения",
        items: [
            "Формирование кабинета клиента",
            "Интерфейс интеграции 1С",
            "Формирование универсальной системы программ для автоматизации",
            "Выставление счёта на оплату и актов",
        ],
    },
    marketing: {
        title: "Услуга маркетингового сопровождения",
        items: ["Реклама на платформе (баннер, бегущая строка)", "Таргетинг", "Реклама в соцсетях"],
    },
    customs: {
        title: "Услуга таможенного сопровождения",
        items: [
            "Интеграция с программой Колдау (электронная очередь)",
            "Регистрация / вход в систему",
            "Указание даты и времени пересечения границы",
            "Выбор пограничного пункта пропуска",
            "Заполнение данных водителя и транспорта",
        ],
    },
    sales: {
        title: "Услуга по сбыту",
        items: [
            "Формирование общего объёма агропродукции",
            "Значки крупных производителей",
            "Актуальные данные по объёму потребления",
            "Запрос на поставку агропродукции",
            "Формирование ценообразования",
        ],
    },
    storage: {
        title: "Услуга хранения",
        items: [
            "Выбор региона",
            "Выбор складского помещения (сухой, температурный, элеватор)",
            "Мониторинг загруженности склада",
        ],
    },
    ses_vet: {
        title: "Услуга СЭС и Вэт",
        items: [
            "Выбор услуги СЭС (дезинсекция, дезинфекция, pest control и др.)",
            "Выдача справки",
            "Выбор региона и управления ветеринарии",
            "Список гос. ветинспекторов и объектов",
            "Выдача документа",
        ],
    },
    packing: {
        title: "Услуга упаковки",
        items: [
            "Выбор упаковки свежих овощей и фруктов",
            "Вакуумная упаковка",
            "Фасовка / упаковка зерновых и круп",
            "Транспортная упаковка (стрейч‑плёнка, паллеты)",
        ],
    },
    logistics: {
        title: "Услуга логистики",
        items: [
            "Выбор региона",
            "Выбор транспортной компании",
            "Формирование заявки и подготовка груза",
            "Выбор времени забора груза",
            "Забор груза",
        ],
    },
    planting: {
        title: "Услуга посадки",
        items: [
            "Выбор специалиста / агронома",
            "Заявка на привлечение специалиста",
            "Трансфер специалиста",
            "Аренда спецтехники и заявка на спецтехнику",
        ],
    },
    harvest: {
        title: "Услуга сбора урожая",
        items: [
            "Планирование сроков уборки",
            "Подбор техники и персонала",
            "Контроль выполнения работ",
        ],
    },
    counterparty: {
        title: "Услуга контроля контрагентов",
        items: ["Значок проверки", "Ввод БИН/ИНН компании", "Получение результата проверки"],
    },
    acquiring: {
        title: "Услуга эквайринга БВУ",
        items: ["Выбор банка", "Интеграция эквайринга", "Запуск приёма оплат"],
    },
    aero: {
        title: "Услуга Агро аэронавигации",
        items: [
            "Воздушные фото‑ и видеосъёмки",
            "Топографическая съёмка дроном",
            "Химическая обработка посева",
            "Подача заявки",
            "Выбор региона и времени получения услуг",
        ],
    },
};

function ServicesSection() {
    const [searchParams] = useSearchParams();
    const serviceId = searchParams.get("service") || "legal";
    const meta = servicesMeta[serviceId] || servicesMeta.legal;
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <section className="mb-10">
            <h1 className="text-xl md:text-2xl font-semibold mb-2">{meta.title}</h1>
            <p className="text-xs text-[#6b7280] mb-4">
                Выберите сервис внутри услуги, чтобы увидеть этапы её оказания.
            </p>

            <div className="grid gap-6 lg:grid-cols-[minmax(260px,320px)_1fr] items-start">
                <div className="space-y-3">
                        {meta.items.map((item, index) => {
                            const isActive = index === activeIndex;
                            return (
                                <button
                                    key={item}
                                    onClick={() => setActiveIndex(index)}
                                    className={`w-full flex rounded-xl overflow-hidden border text-left transition ${
                                        isActive
                                            ? "border-[#147F26] bg-[#147F26]/5"
                                            : "border-[#e5e7eb] bg-white hover:border-[#147F26]"
                                    }`}
                                >
                                    <div className="w-1/3 min-h-[64px] bg-gray-100" />
                                    <div className="flex-1 px-4 py-3 flex items-center text-xs md:text-sm text-[#111827]">
                                        {item}
                                    </div>
                                </button>
                            );
                        })}
                </div>

                <div className="rounded-xl border border-[#e5e7eb] bg-white p-4 text-sm text-[#111827]">
                    <div className="font-semibold mb-2">Выбранный сервис:</div>
                    <div>{meta.items[activeIndex]}</div>
                </div>
            </div>
        </section>
    );
}

export default ServicesSection;

